import { OverlayTriggerProps } from '@procore/core-react/dist/_typedoc/OverlayTrigger/OverlayTrigger.types.json';
import * as React from 'react';
export default {
  OverlayTriggerProps,
  React
};